export const getdata = (recibo, progra) => {
  // window.console.log('succc', suc, recibo,'>',progra);
  let apidev = process.env.VUE_APP_GRAPHQL;
  let ENVIRONMENT = 2 // 2: pruebas, 1: produccion
  if( apidev.includes("apidev") ){
    ENVIRONMENT = 2
  }else{
    ENVIRONMENT = 1
  }

  const items = [];
  let total = 0;
  recibo.detalle.forEach((d, i) => {
    total += d.monto;
    const item = {
      line: i + 1,
      price: '',
      quantity: '1',
    //   internal_code: d.concepto_pago_id,
      description: progra.nombre_compuesto,
      taxes: [
        {
          type: '01',
          code: '00',
          amount: '0',
        },
      ],
      discount: '0',
    //   additional_info: ''+d.concepto,
    };
    items.push(item);
  });

  return {
    header: {
      id: 0,
      environment: ENVIRONMENT, 
      issue_date: 'T00:00:00-05:00', 
    },
    document: { 
      fd_number: 0,
      type: 'FAC',
      sale_type: '1', 
      receptor: {
        type: '',
        name: '',
        ruc: '6-720-659',
        dv: 87,
        location: '',
        ruc_type: '1',
        address: '',
        email: '',
      },
      items: items,
      payments: [
        {
          type: '08',
          amount: total,
          description: 'Descripción del pago',
        },
      ],  
      payment_term: 1,
      trim_amounts: true, 
      /* order_info: {
        number: ''+recibo.id,
        info: ''+progra.nombre_compuesto,
      }, */
    },
  };
};